import { Breadcrumb } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

function InsideHeader({ title, subtitle, back, title1, title2 }) {
  const navigate = useNavigate();

  return (
    <>
      <div className="w-[100%] h-auto bg-white rounded-[10px]  py-[25px] px-10 lg:flex flex-col hidden justify-between items-start">
        {back && (
          <Breadcrumb
            items={[
              {
                title: (
                  <span
                    className="font-dmSans cursor-pointer "
                    onClick={() => navigate(-1)}
                  >
                    {title1}
                  </span>
                ),
              },
              {
                title: (
                  <span className="text-lightBlack font-dmSans">{title2}</span>
                ),
              },
            ]}
          />
        )}

        <div className="flex flex-col">
          <span className="font-bold text-[40px] text-[#141414] dash-title leading-[60.75px]">
            {title}
          </span>
          <span className="text-black21 text-[18px] font-normal leading-[24px] font-dmSans">
            {subtitle}
          </span>
        </div>
      </div>
    </>
  );
}

export default InsideHeader;
